import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function About() {
  return (
    <div className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-slate-900">About BlueFlow Plumbing</h1>
          <p className="text-xl text-slate-600">Setting the standard for plumbing excellence in Montreal for over 15 years.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&q=80" 
              alt="Plumbing Team" 
              className="rounded-2xl shadow-xl w-full h-[400px] object-cover"
            />
          </div>
          <div>
            <h2 className="text-3xl font-bold mb-6">Our Story</h2>
            <p className="text-slate-600 mb-4 text-lg">
              BlueFlow Plumbing & Drain was founded with a simple mission: to provide Montreal homeowners and businesses with plumbing services they can actually trust. Frustrated by an industry plagued by hidden fees and unreliable service, we set out to be different.
            </p>
            <p className="text-slate-600 mb-6 text-lg">
              Today, we are a leading local plumbing contractor, fully licensed by the RBQ. Our team of certified master plumbers and apprentices undergo continuous training to stay ahead of the latest plumbing codes and technologies.
            </p>
            <div className="grid grid-cols-2 gap-6 border-t border-slate-200 pt-6">
              <div>
                <div className="text-3xl font-bold text-primary mb-1">15+</div>
                <div className="text-sm text-slate-500 font-medium uppercase tracking-wide">Years Experience</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary mb-1">10k+</div>
                <div className="text-sm text-slate-500 font-medium uppercase tracking-wide">Jobs Completed</div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-slate-50 rounded-3xl p-12 text-center">
          <h2 className="text-3xl font-bold mb-12">Our Core Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { title: "Honesty", desc: "No hidden fees, no bait-and-switch. We provide upfront pricing.", icon: "CheckSquare" },
              { title: "Quality", desc: "We use premium parts and never cut corners on installations.", icon: "Award" },
              { title: "Respect", desc: "We wear shoe covers, use drop cloths, and clean up after ourselves.", icon: "Heart" }
            ].map((value, i) => (
              <div key={i} className="bg-white p-6 rounded-xl shadow-sm">
                <SafeIcon name={value.icon} className="text-4xl text-secondary mx-auto mb-4" />
                <h3 className="text-xl font-bold mb-2">{value.title}</h3>
                <p className="text-slate-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}